import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiShootingStarBold, PiX } from 'react-icons/pi';
import { useTourStarter } from '@/hooks/useTourStarter';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

const SamplesTour = () => {
  const { t } = useTranslation();
  const [showButton, setShowButton] = useState(false);
  const { startTour } = useTourStarter();

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !localStorage.getItem('samplesTourCompleted') &&
      !localStorage.getItem('samplesTourDismissed') // Add check for dismissed state
    ) {
      setShowButton(true);
    }
  }, []);

  const handleStartTour = () => {
    startTour();
    // Don't hide the button here - let it stay visible until tour is completed
  };

  const handleDismissTour = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the parent button's onClick
    localStorage.setItem('samplesTourDismissed', 'true');
    setShowButton(false);
  };

  if (!showButton) return null;

  return (
    <div className='fixed bottom-24 z-50 right-4 flex flex-col items-end'>
      <button
        onClick={handleStartTour}
        className='flex items-center gap-1 bg-gradient-to-r from-accent-blue to-cyan-500 text-base font-medium text-white px-3 py-1.5 rounded-md shadow-lg hover:bg-accent-blue transition-colors'
      >
        <PiShootingStarBold size={16} /> {t('tours.mainTour.start_tour')}
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span
                onClick={handleDismissTour}
                className='ml-2 p-1 rounded-full text-white hover:text-zinc-600 transition-colors'
              >
                <PiX size={14} />
              </span>
            </TooltipTrigger>
            <TooltipContent
              variant='zinc'
              sideOffset={6}
              side='top'
              className='text-xs mr-2'
            >
              {t('tours.mainTour.dismiss_tour')}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </button>
    </div>
  );
};

export default SamplesTour;
